const recommend = {
  getlist: 'recommend/getlist',
  add: 'recommend/add',
  update: 'recommend/update',
  remove: 'recommend/remove',
  get: 'recommend/get',
  getall: 'recommend/getall',
}
export default recommend
